import { render, staticRenderFns } from "./WorkspaceManagement.vue?vue&type=template&id=2390eb89&scoped=true&"
import script from "./WorkspaceManagement.vue?vue&type=script&lang=js&"
export * from "./WorkspaceManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2390eb89",
  null
  
)

export default component.exports